<template>
    <div class="list__status">
        <!-- display: none -->
        <span class="icon" v-show="isTracking"> <span class="icon__symbol"><SvgIcon class="icon" name="common__status_tracking" /></span> </span>
        <span class="icon" v-show="!isTracking && !isOnMap"> <span class="icon__symbol"><SvgIcon class="icon" name="common__status_not_show" /></span> </span>
        <!-- common__status_not_show common__status_tracking -->
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "UnitsList_unit__status",
        mixins: [],
        props: {
            unitId: Number,
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                "getUnitsOnMap",
            ]),
            unitIdByRoute() {
                return this.routeFilter.unitId
            },
            isOnMap(){
                return this.isTracking || this.getUnitsOnMap.includes(this.unitId)
            },
            isTracking(){
                return this.unitIdByRoute === this.unitId
            },

        },
        methods: {
        },
        updated: function() {
            // console.log(`unit status ${this.unitId} updated`);
        },
    }
</script>

<style scoped>

</style>